import { ThemeProvider, CssBaseline } from '@mui/material';
import { useBlockNumberWheel } from '@bluplanet/shared';
import { AppProvider } from '@/contexts/AppContext';
import { MockDataProvider } from '@/contexts/MockDataContext';
import { NodeConfigProvider } from '@/utils/nodeConfig';
import { AppRouter } from '@/router';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import theme from '@/theme';

export default function App() {
  // 后台是桌面工具，价格/数量数字框误滚一格里真金白银 —— 全站屏蔽滚轮增减（聚焦时生效，不抢页面滚动）
  useBlockNumberWheel();
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppProvider>
          <MockDataProvider>
            <NodeConfigProvider>
              <AppRouter />
            </NodeConfigProvider>
          </MockDataProvider>
        </AppProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
